import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdgerunnerLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1080 896.55",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #ce0d0d;\n      }\n\n      .cls-2 {\n        fill: #e9222c;\n      }\n\n      .cls-3 {\n        fill: #ed2827;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-3",
			points: "212.58 341.99 0 554.57 313.26 554.57 212.58 341.99"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "525.84 341.99 212.58 341.99 313.26 554.57 525.84 341.99"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-3",
			points: "0 896.55 313.26 896.55 212.58 683.97 0 896.55"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "313.26 896.55 525.84 683.97 212.58 683.97 313.26 896.55"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-3",
			points: "908.27 681.7 506.05 554.67 779.29 896.55 1080 896.55 908.27 681.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-3",
			d: "M313.26,212.58L525.84,0h269.09c41.12,0,79.75,10.6,113.34,29.19,25.81,14.28,48.65,33.27,67.34,55.82,29.28,35.35,48.41,79.27,52.82,127.6.75,7.24,1.08,14.56,1.08,21.96,0,64.8-26.29,123.36-68.71,165.87l-52.16,52.16-101.96,101.98.07.08-300.52-.05-.19.05,304.45-304.54c3.91-3.99,6.41-9.48,6.41-15.55,0-12.15-9.82-21.96-21.96-21.96l-481.67-.04Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "806.74 554.67 506.05 554.67 908.27 681.7 806.74 554.67"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-2",
			points: "212.56 0 96.27 116.3 .02 212.59 313.24 212.59 212.56 0"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "525.84 0 212.58 0 313.26 212.59 525.84 0"
		})
	]
});
const ForwardRef = forwardRef(SvgEdgerunnerLogo);
export { ForwardRef as ReactComponent };
